import * as ActionTypes from "../ActionTypes";
import * as URL from "../API_URL";
import {
  getRequest,postRequest
} from "./index";

export const getUserManagementData = () => {
    let url = URL.GET_USER_MANAGEMENT_DATA;
    return getRequest(url, ActionTypes.GET_USER_MANAGEMENT_DATA);
  };
export const setUserManagementState = (type, data) => {
    return {
      type: ActionTypes.SET_USER_MANAGEMENT_STATE_PARAMS,
      payload: { type: type, data: data },
    };
  };

  export const getUserRoleChangeData = (payload) => {
    let url = URL.GET_USER_ROLE_CHANGE;
    return postRequest(url,payload, ActionTypes.GET_USER_ROLE_CHANGE);
  };
  // export const getUserRoleChangeData1 = (payload) => {
  //   let url = URL.GET_USER_ROLE_CHANGE1;
  //   return postRequest(url,payload, ActionTypes.GET_USER_ROLE_CHANGE1);
  // };